import { makeAutoObservable } from 'mobx';
import { Col, ReportOrgFilters, TableDataT } from '../components/reports/ReportDetailOrg';
import apiConfig from '../api/routes';
import { HrReportDto, HrReportResponse, OrgReportSettings, OrgReportSettingsUpdateDto, OrgReportPayload } from '../types';

class ReportDetailsOrg{
  constructor() {
    makeAutoObservable(this);
  }
  fetchingData = false;
  tableData: TableDataT = { result: [], total: 0 };
  tableHeader: Col[] = [];
  hrReportData: HrReportResponse = { categories: [], employeesDtoList: [], total: 0, firstNameAndLastNameOfInvalidUsers: [] };
  configuration:OrgReportSettings = {
    allDivisionsSelected: false,
    allLocationsSelected: false,
    divisionTreeForHrReportFilterDtos: [],
    locations: [],
    includeB2B: false,
    includeOnlyPendingAbsence: false
  };
  fetchTableData = async (toApi: ReportOrgFilters) => {
    this.fetchingData = true;
    try{
      this.tableData = await apiConfig.reportService.getOrgReportTableData(toApi);
      this.fetchingData = false;
    }
    catch (e) {
      this.fetchingData = false;
    }
  };

  fetchNewTableData = async (data: HrReportDto) => {
    this.fetchingData = true;
    try{
      this.hrReportData = await apiConfig.reportService.getOrgReportDataWithHrProperties(data);
      this.fetchingData = false;
    }
    catch (e) {
      this.fetchingData = false;
    }
  };

  getConfiguration = async () => {
    this.configuration = await apiConfig.reportService.getFilters();
  };

  updateConfiguration = async (configurationDto: OrgReportSettingsUpdateDto) => {
    apiConfig.reportService.updateFilters(configurationDto);
  };

  fetchTableHeader = async () => {
    this.tableHeader = await apiConfig.reportService.getOrgReportTableHeader();
  };
  downloadTimesheetData = async (dateToApi: string, userIds: number[]) => {
    return apiConfig.reportService.getOrgReportTimesheetData(dateToApi, userIds);
  };
  downloadTimesheetDataAll = async (payload: OrgReportPayload) => {
    return apiConfig.reportService.getOrgReportTimesheetDataAll(payload);
  };
}

export const ReportDetailsOrgStore = new ReportDetailsOrg();
